module.exports = __webpack_public_path__ + "img/The Basic 6-Digit USSGL Accounts Classification_150ppi.e2c918a7.png";